export enum Routes {
  ABOUT = '/about',
  BASKET = '/basket',
  CANCELLATION_POLICY = '/cancellation-policy',
  CONFIRMATION = '/confirmation',
  FORGOTTEN_PASSWORD = '/forgotten-password',
  HOME = '/',
  MY_ACCOUNT = '/my-account',
  MY_ACCOUNT_ORDERS = '/my-account/orders',
  MY_ACCOUNT_PERSONAL_DETAILS = '/my-account/personal-details',
  ORDER_DETAIL = '/orders/[id]',
  ACCOUNT_ORDERS = '/my-account#orders',
  PRIVACY_POLICY = '/privacy-and-cookies',
  REGISTER = '/register',
  SEARCH = '/search',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
  SIGNIN = '/signin',
  SET_PASSWORD = '/set-password',

  CHECKOUT_BILLING = '/checkout/billing',
  CHECKOUT_PAYMENT = '/checkout/payment',
  CHECKOUT_ACKNOWLEDGEMENT = '/checkout/acknowledgement',
  CHECKOUT_PRODUCT_DELIVERY = '/checkout/product-delivery',
  CHECKOUT_SIGNIN = '/checkout/signin',
  CHECKOUT = '/checkout',

  CATEGORY_LIST = '/categories',
  CATEGORY_DETAIL = '/categories/[id]',

  EVENT_LIST = '/events',
  EVENT_DETAIL = '/events/[id]',

  PRODUCT_LIST = '/products',
  PRODUCT_DETAIL = '/products/[id]',

  RATE_LIST = '/rates',
  RATE_DETAIL = '/rates/[id]',
  RATE_BOOKING = '/rates/[id]/[bookingStep]/[room]',
  SPA_STAYS_LIST = '/rates/spastays',
  SPA_STAYS_DETAIL = '/rates/spastays/[id]',
  SPA_STAYS_BOOKING = '/rates/spastays/[id]/[bookingStep]/[room]',

  ROOM_LIST = '/rooms',
  ROOM_DETAIL = '/rooms/[id]',
  ROOM_BOOKING = '/rooms/[id]/[bookingStep]/[rate]',

  SPA_HOME = '/spa',
  SPA_CLASSES_LIST = '/spa/classes',
  SPA_CLASSES_BOOKING = '/spa/classes/[id]/[bookingStep]',

  SPA_DAY_LIST = '/spa/days',
  SPA_DAY_DETAIL = '/spa/days/[id]',
  SPA_DAY_BOOKING = '/spa/days/[id]/[bookingStep]',
  SPA_DAY_CATEGORY_LIST = '/spa/days/category',
  SPA_DAY_CATEGORY_DETAIL = '/spa/days/category/[id]',

  SPA_TREATMENT_LIST = '/spa/treatments',
  SPA_TREATMENT_DETAIL = '/spa/treatments/[id]',
  SPA_TREATMENT_BOOKING = '/spa/treatments/[id]/[bookingStep]',
  SPA_TREATMENT_CATEGORY_LIST = '/spa/treatments/category',
  SPA_TREATMENT_CATEGORY_DETAIL = '/spa/treatments/category/[id]',

  FACILITY_LIST = '/spa/facilities',
  FACILITY_DETAIL = '/spa/facilities/[id]',
  FACILITY_BOOKING = '/spa/facilities/[id]/[bookingStep]',
  FACILITY_CATEGORY_LIST = '/spa/facilities/category',
  FACILITY_CATEGORY_DETAIL = '/spa/facilities/category/[id]',

  TABLES_HOME = '/tables',
  TABLES_BOOK = '/tables/book',
  TABLES_BOOK_RESTAURANT = '/tables/book/[restaurant]',

  GOLF_HOME = '/golf',
  GOLF_PLAY_COURSE_LIST = '/golf/play',
  GOLF_PLAY_COURSE = '/golf/play/[course]',
  GOLF_PLAY_TEE_TIMES = '/golf/play/[course]/tee-times',
  GOLF_PLAY_PLAYERS = '/golf/play/[course]/players',

  VOUCHER_LIST = '/vouchers',
  VOUCHER_DETAIL = '/vouchers/[id]',
}
